import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
// import moment from 'moment';
// import buildExportQuery from './queryies/_export_all';
import { saveAs } from 'file-saver';
import moment from 'moment';

interface WorkPlanBoardState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
}

const state: WorkPlanBoardState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
};

export const ITEMS_LIST = 'GET_CLIENT_LIST';

export const actions: ActionTree<WorkPlanBoardState, RootState> = {
    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const columns: any = {
                id: 'vehicles.id',
                model: 'vehicles.model',
                number: 'vehicles.number',
                created_at: 'vehicles.created_at',
                updated_at: 'vehicles.updated_at',
                archived_at: 'vehicles.archived_at',
                drivers: 'grouped_employee_vehicles.drivers'
              };

            const filter: any[] = [];

            if (query.model) {
                filter.push({ "$ilike": ["vehicles.model", {"$": `%${query.model}%`}] })
            }

            if (query.number) {
                filter.push({ "$ilike": ["vehicles.number", {"$": `%${query.number}%`}] })
            }

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    "columns": columns,
                    from: 's:vehicles',
                    from_as: 'vehicles',
                    joins: [
                        {
                            join: {
                              columns: {
                                vehicle_id: 'employee_vehicles.vehicle_id',
                                drivers: {
                                    $array_agg: {
                                      $obj: {
                                        // product_name: 'employee_vehicles.product_name',
                                        id: 'employee_vehicles.id',
                                        name: 'employees.name',
                                        employee_id: 'employee_vehicles.employee_id',
                                        driver_hour_rate: 'employee_vehicles.driver_hour_rate',
                                        driver_fixed_rate: 'employee_vehicles.driver_fixed_rate',
                                        created_at: 'employee_vehicles.created_at',
                                        updated_at: 'employee_vehicles.updated_at',
                                        archived_at: 'employee_vehicles.archived_at',
                                      }
                                    }
                                  },
                              },
                              joins: [
                                {
                                    join: 's:employees',
                                    type: 'left',
                                    as:   'employees',
                                    on: {
                                        $eq: ['employee_vehicles.employee_id', 'employees.id']
                                    }
                                },
                              ],
                              from: 's:employee_vehicles',
                              from_as: 'employee_vehicles',
                              groups: [
                                'employee_vehicles.vehicle_id'
                              ],
                            },
                            type: 'left',
                            as: 'grouped_employee_vehicles',
                            on: { $eq: ['grouped_employee_vehicles.vehicle_id', 'vehicles.id'] }
                        }
                    ],
                    page_size: 10,
                    ...({page: parseInt(query.page) || 1}),
                    ...({
                        order: [
                            query.sortDirection == 'desc' ? { $desc: [columns[query.sortField || 'model' ]] } : { $asc: [columns[query.sortField || 'model']] }
                        ]
                    }),
                    ...(
                        filter.length > 1 ?
                        {
                            "where": {
                                "$and": filter
                            }
                        } : {
                            "where": filter[0]
                        }
                    )

                })
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve();
            }));
        })
    },

    driverToUnarchive({ rootState }, driverId) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('DRIVER_TO_ARCHIVE')
                    .update(driverId, {
                        archived_at: null
                    })
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('DRIVER_TO_ARCHIVE');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

    driverToArchive({ rootState }, driverId) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('DRIVER_TO_ARCHIVE')
                    .update(driverId, {
                        archived_at: moment().format('YYYY-MM-DDTHH:mm:ss')
                    })
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('DRIVER_TO_ARCHIVE');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

    veichelToArchive({ rootState }, veichelId) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('VEICHEL_TO_ARCHIVE')
                    .update(veichelId, {
                        archived_at: moment().format('YYYY-MM-DDTHH:mm:ss')
                    })
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('VEICHEL_TO_ARCHIVE');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

    veichelToUnarchive({ rootState }, veichelId) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('VEICHEL_TO_ARCHIVE')
                    .update(veichelId, {
                        archived_at: null
                    })
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('VEICHEL_TO_ARCHIVE');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

    setProductContainerCost({ rootState }, data) {
        const vm = (this as any)._vm;

        const query = data.id ?
            vm.$q('SAVE_PRIME_COST').update(data.id, data) :
            vm.$q('SAVE_PRIME_COST').create('prime_costs', data);

        return new Promise((resolve, reject) => {
            vm.$db([
                query
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('SAVE_PRIME_COST');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },
};

export const mutations: MutationTree<WorkPlanBoardState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents;

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {

};

export const STORE_KEY = '$_delivery_vehicles_manager';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
